import { Container, Typography, Box, Grid } from "@mui/material";
import { useLang } from "../context/LanguageContext";
import logo from "../components/logo.svg";

export default function About() {
  const { t } = useLang();

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", minHeight: "100vh" }}>
      <Box sx={{ height: 64 }} />

      <Box
        sx={{
          py: 10,
          background: "linear-gradient(135deg, #1c1c1c 0%, #222 100%)",
          color: "#f0f0f0",
          textAlign: "center",
        }}
      >
        <Container>
          <img src={logo} alt="Mazur Masz" height={240} />
          <Typography variant="h3" sx={{ mt: 4, fontWeight: 700 }}>
            {t("about.title")}
          </Typography>
          <Typography variant="h6" sx={{ opacity: 0.8, mt: 1 }}>
            {t("about.subtitle")}
          </Typography>
        </Container>
      </Box>

      <Container sx={{ py: 8, color: "#f0f0f0" }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              {t("about.heading")}
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
              {t("about.body")}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
